import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {},
	cellStyle: {
		width: '7.25rem',
	},
}));
